<template>
  <div>
    <v-app-bar
      dark
      color="secondary"
    >
      <NuxtLink
        to="/"
        aria-label="Go to homepage"
        class="ml-md-6 logo-link"
      >
        <img
          class="logo"
          src="/compressed/el.webp"
          height="50"
          width="250"
          alt="Explicit Lures logo"
        >
      </NuxtLink>

      <v-spacer />

      <nav
        v-if="!isLoading && !mobile"
        class="d-flex flex-row justify-space-around align-center"
        style="min-width: 25%;"
        aria-label="Main navigation"
      >
        <template
          v-for="link in menuItems.filter(link => !link.props.mobile)"
          :key="link.title"
        >
          <NuxtLink
            v-if="!link.props.mobile"
            class="text-white text-decoration-none font-weight-bold"
            :to="link.props.to"
          >
            {{ link.title }}
          </NuxtLink>
        </template>
      </nav>

      <v-badge
        v-if="!mobile"
        class="nav-icon mr-6"
        :color="isShowCounter ? 'primary' : 'transparent'"
        :content="isShowCounter ? cartCount : undefined"
      >
        <button
          class="icon-button"
          aria-label="View shopping cart"
          @click="$emit('goToCart')"
        >
          <v-icon>mdi-shopping-outline</v-icon>
        </button>
      </v-badge>
    </v-app-bar>
  </div>
</template>

<script lang="ts" setup>
import { useDisplay } from 'vuetify'
import { useLoading } from '~/composables/useLoading'
import { computed } from 'vue'
import type { PropType } from 'vue'
import type MenuItem from '~/models/menuItem'

const props = defineProps({
  items: {
    type: Object as PropType<MenuItem[]>,
    required: true,
  },
  cartCount: {
    type: Number,
    default: 0,
  },
  isShowCounter: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:items', 'update:drawer', 'goToCart'])

const menuItems = computed({
  get: () => props.items,
  set: (value: MenuItem) => {
    emit('update:items', value)
  },
})

const { isLoading } = useLoading()
const { mobile } = useDisplay()
</script>

<style scoped>
.logo {
  max-height: 50px;
  margin-left: 24px;
}

.logo-link {
  display: inline-block;
}

.icon-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: inherit;
}

:deep(.v-toolbar__content) {
  justify-content: space-between;
}

@media screen and (max-width: 600px) {
  .logo {
    max-width: 225px;
    margin-left: 32px;
  }
}
</style>
